import image1 from './vertical portfolio/1.jpg';
import image2 from './vertical portfolio/2.jpg';
import image3 from './vertical portfolio/3.jpg';
import image4 from './vertical portfolio/4.jpg';
import image5 from './vertical portfolio/5.jpg';
import image6 from './vertical portfolio/6.jpg';
import image7 from './vertical portfolio/7.jpg';
import image8 from './vertical portfolio/8.jpg';
import image9 from './vertical portfolio/9.jpg';
import image10 from './vertical portfolio/10.jpg';
import image11 from './vertical portfolio/11.jpg';
import image12 from './vertical portfolio/12.jpg';
import image13 from './vertical portfolio/13.jpg';
import image14 from './vertical portfolio/14.jpg';
import image15 from './vertical portfolio/15.jpg';
import image16 from './vertical portfolio/16.jpg';
import image17 from './vertical portfolio/17.jpg';
import image18 from './vertical portfolio/18.jpg';
import image19 from './vertical portfolio/19.jpg';
import image20 from './vertical portfolio/20.jpg';
import image21 from './vertical portfolio/21.jpg';
import image22 from './vertical portfolio/22.jpg';
import image23 from './vertical portfolio/23.jpg';
import image24 from './vertical portfolio/24.jpg';
import image25 from './vertical portfolio/25.jpg';
import image26 from './vertical portfolio/26.jpg';
import image27 from './vertical portfolio/27.jpg';
import image28 from './vertical portfolio/28.jpg';
import image30 from './vertical portfolio/30.jpg';

// Store images in an array
const verticalPortfolio = [
  image1, image2, image3, image4, image5, image6, image7, image8, image9, image10,
  image11, image12, image13, image14, image15, image16, image17, image18, image19, image20,
  image21, image22, image23, image24, image25, image26, image27, image28, image30,
];

// Export the array
export default verticalPortfolio;
